module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p5-B-5d78a70151e499011372eb134d51afbc.png";